import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import { Chip, Stack, CircularProgress, Button } from "@mui/material"
import dayjs from "dayjs"
import { useState } from "react"
import { approveFee, escalateFee } from "../../api"
import { useSnackbar } from "notistack"

const currencyMap = {
  INR: "₹",
  USD: "$",
}

const FeePayApproveCard = ({ data, reset }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const onClickEscalate = (id) => {
    setLoading(true)
    escalateFee(id)
      .then(() => {
        enqueueSnackbar("Fees Status updated!", { variant: "success" })
        reset()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  const onClickApprove = (id) => {
    setLoading(true)
    approveFee(id)
      .then(() => {
        enqueueSnackbar("Fees Status updated!", { variant: "success" })
        reset()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  const disabledAction =
    data.approvalStatus === "ESCALATED" || data.approvalStatus === "APPROVED"

  return (
    <CardContainer
      disableEditDelete
      SummaryContent={
        <>
          <CardStat
            label="Amount"
            value={
              currencyMap[data.currency] +
              " " +
              parseFloat(data.amount).toFixed(2)
            }
          />

          <CardStat label="Payment mode" value={data.modeOfPayment} />
          <CardStat
            label="Payment date"
            value={dayjs(data.paymentDate).format("DD-MM-YYYY")}
          />
          <CardStat
            label="Payment status"
            value={<Chip label={data.paymentStatus || "N/A"} color="success" />}
          />
          <CardStat
            label="Approval Status"
            value={<Chip label={data.approvalStatus} color="success" />}
          />
        </>
      }
      ActionButtons={
        <Stack direction="row" spacing={5} alignItems="center">
          <Button
            disabled={disabledAction}
            onClick={() => onClickEscalate(data.id)}
          >
            {loading ? <CircularProgress /> : "Escalate"}
          </Button>
          <Button
            disabled={disabledAction}
            onClick={() => onClickApprove(data.id)}
            variant="contained"
          >
            {loading ? <CircularProgress /> : "Approve"}
          </Button>
        </Stack>
      }
    />
  )
}

export default FeePayApproveCard
